"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Converter_1 = require("./Converter");

var SerializationError_1 = require("./Error/SerializationError");

var Deserializer =
/** @class */
function () {
  function Deserializer(converter) {
    this._converter = converter || new Converter_1.Converter();
  }

  Deserializer.prototype.deserialize = function (target, input) {
    if (!input) {
      throw new SerializationError_1.SerializationError('Input must not be empty', {
        input: input
      });
    } // noinspection SuspiciousTypeOfGuard


    if (typeof input !== 'string' && !(input instanceof String)) {
      throw new SerializationError_1.SerializationError('Input must be of type string', {
        input: input
      });
    }

    var raw;

    try {
      raw = JSON.parse(input);
    } catch (error) {
      throw new SerializationError_1.SerializationError(error.message + ' ' + input, {
        error: error,
        input: input
      });
    }

    var converter = this._converter;

    if (input.charAt(0) === '[') {
      return converter.convertCollection(target, raw);
    } else {
      var result = converter.convertSingle(target, raw);

      if (result === null) {
        throw new SerializationError_1.SerializationError('Could not convert input', {
          input: input
        });
      }

      return result;
    }
  };

  return Deserializer;
}();

exports.Deserializer = Deserializer;